import { SVGProps, Ref, forwardRef } from 'react';

export const DropsFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M10 0s1.108 1.05 2.5 2.804c-1.17 1.9-2.3 4.434-2.3 7.196a6.8 6.8 0 0 0 7.765 6.73A7.999 7.999 0 0 1 2 16c0-8.418 8-16 8-16"
            fill="currentColor"
        />
        <path d="M17 0s5 4.739 5 10a5 5 0 0 1-10 0c0-5.261 5-10 5-10" fill="currentColor" />
    </svg>
));
DropsFilledSize24Glyph.displayName = 'DropsFilledSize24Glyph';
